import { OrderAdministrationContainer } from 'components/order/OrderAdministrationContainer';
import React from 'react';
import { ePermissions } from '../../types/administration/userAdministration/ePermissions';
import { AccessControlCheck } from 'components/accessControl/AccessControlCheck';

export const OrderAdministrationPage: React.FC = () => {
  return (
    <AccessControlCheck allowedPermissions={[ePermissions.AdminEdit]}>
      <OrderAdministrationContainer />
    </AccessControlCheck>
  );
};
